import { memo } from "react";

import { Allocation } from "./Allocation";
import { useAllocationSetup } from "./hooks/useAllocationSetup";

export const AllocationsEdit = memo(() => {
  const { allocationId } = useAllocationSetup();

  return <Allocation edit allocationId={allocationId} />;
});

AllocationsEdit.displayName = "Edit Allocation";
